var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"mb-3"},[_c('strong',[_vm._v("Stock Information")])]),_c('div',[_vm._v("Coming Soon...")])])
}]

export { render, staticRenderFns }